import { Box, Button, Flex, Spinner, Text, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as types from "../../../Redux/App/app.actionTypes";

import Papa from "papaparse";
import * as XLSX from "xlsx";
// import { handleTransformControllers } from "../HomeStepper";
import {
  ErpConverterAPI,
  addFileAPI,
  updateErpRawFile,
} from "../../../Redux/App/app.actions";
import FileUploaderPro from "../../FileUploader/FIleUploaderPro";
import { mixpanelTrackButton } from "../../utils/mixpanelFunctions";
import { DynamicDataGrid } from "./DynamicDataGrid";
import { uploadDataReadyFileApi } from "./services/stepZeroServices";
export const columnSequence = [
  "lotno",
  "type",
  "description",
  "available_qnty",
  "Cr2O3",
  "FeO",
  "Fe2O3",
  "SiO2",
  "MgO",
  "Al2O3",
  "CaO",
  "P",
  "S",
  "FC",
  "ASH",
];

export const StepZero = ({ onSuccess, dataReadyArray, setDataReadyArray }) => {
  console.log(dataReadyArray);
  const [erpFile, setErpFile] = useState(null);
  const [dataReadyFile, setDatareadyFile] = useState(null);

  const dispatch = useDispatch();

  const toast = useToast();
  const state = useSelector((state) => state);
  const { binStatus } = state.app;
  const { postDataForApi } = binStatus;

  const raw_file = state?.app?.erp_file?.raw_file || null;
  const inputFile = state?.app?.inputFile || null;
  const isLoading = state?.app?.erp_file?.isLoading || false;
  const assumptions = state?.app?.bounds?.assumptions;

  const bounds = useSelector((state) => state.app.bounds);
  const steps = bounds?.steps;
  const constraints = bounds?.constraints;
  const controllers = bounds?.controllers;
  const bounds_id = useSelector((state) => state.app.bounds_id);

  const convertCsvToJson = (file) => {
    try {
      Papa.parse(file, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        complete: (result) => {
          // console.log("RESULTS : ", result.data);
          setDataReadyArray((prev) => result.data);
        },
      });
    } catch (e) {}
  };

  const convertExcelToJson = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        const result = e.target.result;
        const workbook = XLSX.read(result, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const arr = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const headers = arr[0];
        const rows = arr.slice(1);
        const objects = rows.reduce((acc, row) => {
          // Check if the row has any non-empty cells
          const hasValue = row.some(
            (cell) => cell !== undefined && cell !== null && cell !== ""
          );
          if (hasValue) {
            // If the row has at least one non-empty cell, add it to the objects array
            const obj = {};
            headers.forEach((header, index) => {
              obj[header] = row[index];
            });
            acc.push(obj);
          }
          return acc;
        }, []);
        setDataReadyArray((prev) => objects);
      };
      reader.readAsBinaryString(file);
    } catch (e) {}
  };

  const updateFileData = (file) => {
    try {
      if (file) {
        switch (file.type) {
          case "application/vnd.ms-excel": {
            convertExcelToJson(file);
            break;
          }
          case "text/csv": {
            convertCsvToJson(file);
            break;
          }
          default:
            convertExcelToJson(file);
            break;
        }
      } else {
        setDataReadyArray([]);
      }
    } catch (e) {}
    //this function converts the uploaded file into array of objects
  };

  const handleChangeDataReadyFile = (file) => {
    setDatareadyFile((prev) => file);
    dispatch(addFileAPI(file));
    uploadDataReadyFileApi(file)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    updateFileData(dataReadyFile);
  }, [dataReadyFile]);

  // useEffect(() => {
  //   if (inputFile) {
  //     dispatch(inConsistancy(state));

  //     handleTransformControllers(
  //       steps,
  //       constraints,
  //       controllers,
  //       inputFile,
  //       dispatch,
  //       transformControllersAPI,
  //       transformControllersAPI2,
  //       types,
  //       updateConstraintsAPI,
  //       bounds_id,
  //       bounds,
  //       toast,
  //       postDataForApi
  //     );
  //   }
  // }, [inputFile]);

  useEffect(() => {
    console.log("Use Effect runnig");
    setErpFile((prev) => raw_file);
    setDatareadyFile((prev) => inputFile);
  }, [raw_file, inputFile]);

  const handleConvertErpFile = () => {
    if (!erpFile) {
      return toast({
        title: "No ERP file found",
        description: "Please upload the ERP file to continue",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
    let ash_analysis_assumption = {};

    assumptions.forEach((elem) => {
      let { category } = elem;

      if (!category) {
        // formdata.append(elem.name, Number(elem.value));
      } else {
        let { name, category, value } = elem;
        if (!ash_analysis_assumption[category]) {
          ash_analysis_assumption[category] = {
            [name]: value,
          };
        } else {
          ash_analysis_assumption[category] = {
            ...ash_analysis_assumption[category],
            [name]: value,
          };
        }
      }
    });
    console.log({ ash_analysis_assumption });

    dispatch(ErpConverterAPI(erpFile, ash_analysis_assumption))
      .then((res) => {
        console.log(res, "res");
        if (res.type === types.ERP_CONVERT_FAILURE) {
          toast({
            title: res?.payload?.response?.data?.error
              ? "Error in format"
              : "Network error",
            description:
              res?.payload?.response?.data?.error ||
              "A network error occurred while converting",
            status: "error",
            duration: 15000,
            isClosable: true,
          });
        } else if (res.type === types.ERP_CONVERT_SUCCESS) {
          console.log("success");
          mixpanelTrackButton("home", "Convert ERP to Data Ready"); // track button
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeErpFile = (file) => {
    setErpFile((prev) => file);
    dispatch(updateErpRawFile(file));
  };

  return (
    <Box w="100%">
      <Flex justify="space-around" alignItems="top">
        <Flex direction="column" gap="1rem">
          <FileUploaderPro
            title={"ERP FILE"}
            file={erpFile}
            onChange={handleChangeErpFile}
          />
          <Button
            colorScheme="orange"
            onClick={handleConvertErpFile}
            disabled={isLoading}
          >
            {isLoading ? (
              <Flex gap="1rem">
                <Text>Converting</Text>
                <Spinner color="white" />
              </Flex>
            ) : (
              "Convert ERP to Data Ready"
            )}
          </Button>
        </Flex>

        <Text fontSize="20px" mt="20px">
          OR
        </Text>
        <Box>
          <FileUploaderPro
            title={"DATA READY FILE"}
            file={dataReadyFile}
            onChange={handleChangeDataReadyFile}
          />
        </Box>
      </Flex>
      <Box>
        {/* {dataReadyFile && (
          <DynamicTable
            height={"50vh"}
            data={dataReadyArray}
            headers={columnSequence}
          />
        )} */}
        {dataReadyFile && (
          <DynamicDataGrid
            height={"50vh"}
            data={dataReadyArray}
            headers={columnSequence}
          />
        )}
      </Box>
    </Box>
  );
};
